import { CurrentTariff, PreviousTariff } from '@/types/marketplace'

export type ProjectBillingStatus = 'open' | 'lock' | 'beforeTrial'

export function getProjectBillingStatus(params: {
    billingEnabled: boolean
    billingBlock: boolean
    currentTariff?: CurrentTariff | null
    previousTariff?: PreviousTariff | null
    isTrialActivatedBefore: boolean
}): ProjectBillingStatus {
    if (!params.billingEnabled) return 'open'
    if (params.billingBlock) return 'lock'
    if (params.currentTariff) return 'open'
    if (params.previousTariff) return 'lock'
    if (!params.isTrialActivatedBefore) return 'beforeTrial'
    return 'lock'
}

export function isBillingBlocked(status: ProjectBillingStatus): boolean {
    return status === 'lock'
}

export function isProjectContentAvailable(status: ProjectBillingStatus): boolean {
    return status === 'open' || status === 'beforeTrial'
}
